module.exports = __webpack_public_path__ + "static/img/xd_5_e.d32164d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xd_5_e.png
// module id = xTOy
// module chunks = 1